import React from 'react';
import LoadingSpinner from '../../shared/LoadingSpinner';

const QuoteBuilderLayout = ({ drawing, loading, children }) => {
  return (
    <div className="card" style={{ margin: '10px' }} data-widget-element="layout-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <h3 style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }} data-widget-element="title">
            {t('quote_builder_widget.get_a_quote')}
          </h3>
          <div className="row">
            <div className="col-5" data-widget-element="image-column">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {drawing.image !== undefined && (
                  <img
                    src={drawing.image.three_d_image_url}
                    style={{ width: '100%', height: 'auto' }}
                    alt="3D Preview"
                    data-widget-element="preview-image"
                  />
                )}
              </div>
            </div>
            <div className="col-7" style={{ padding: '20px' }} data-widget-element="form-column">
              <div data-widget-element="form-section">
                {children}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuoteBuilderLayout;
